class WarrantyWidget extends HTMLElement {
  constructor() {
    super();

    window.defaultActive = false;
    
    // if this is the first widget to render
    if (document.querySelectorAll('warranty-widget').length < 1) {
      if (window.defaultActive || window.warrantyActive) {
        window.warrantyActive = true;
        this.classList.add('active')
      } else {
        window.warrantyActive = false;
      }
    } else {
      if (window.warrantyActive) {
        window.warrantyActive = true;
        this.classList.add('active')
      } else {
        window.warrantyActive = false;
      }
      // if this is the second widget to render
    }

    this.toggle = this.querySelector('.warranty-toggle');

    this.addEventListener('click', () => this.toggleWarranty());
  }

  toggleWarranty() {
    
    if (window.warrantyActive) {
      document.querySelectorAll('warranty-widget').forEach(warrantyToggle => {
        warrantyToggle.classList.remove('active')
        window.warrantyActive = false;
        console.log('removing warranty from cart');
      })
    } else {
      document.querySelectorAll('warranty-widget').forEach(warrantyToggle => {
        warrantyToggle.classList.add('active')
        window.warrantyActive = true;
        console.log('Adding warranty to cart');
      })
    }
  
  }

}

customElements.define('warranty-widget', WarrantyWidget);